import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useVerifyComms } from '~shared/queries/query-keys/verifications';
import { CommsVerificationStatus } from './CommsVerificationStatus';

type RouteParams = {
  commsChannel: string;
  token: string;
};

export const CommsVerificationStatusContainer = () => {
  const { mutateAsync: verifyComms, isPending: loading } = useVerifyComms();
  const [isVerified, setIsVerified] = useState<boolean | null | undefined>(null);
  const { commsChannel = '', token = '' } = useParams<RouteParams>();
  // Verify once per channel+token — guard so an effect re-run can't double-submit.
  const firedForRef = useRef<string | null>(null);

  useEffect(() => {
    if (commsChannel !== 'phone' && commsChannel !== 'email') {
      return;
    }
    const key = `${commsChannel}:${token}`;
    if (firedForRef.current === key) {
      return;
    }
    firedForRef.current = key;
    verifyComms({ commsChannel, token })
      .then((verified) => {
        setIsVerified(verified);
        return verified;
      })
      .catch(() => {
        setIsVerified(false);
      });
  }, [commsChannel, token, verifyComms]);

  return (
    <CommsVerificationStatus
      isVerified={isVerified}
      loading={loading}
      commsChannel={commsChannel}
      token={token}
      authorized
    />
  );
};
